import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "./../../base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ILevelInfo } from "src/app/interfaces/levelInfo";

@Injectable({
  providedIn: "root"
})
export class LevelInfoService {
  constructor(private core: CoreService) {}

  getAllLevelForTeacher(
    page: number = 0,
    pageSize: number = 0
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.getAllLevelForTeacher,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  getList(
    packageId: number,
    page: number = 1,
    pageSize: number = 100000
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.list + packageId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getActiveList(
    packageId: number,
    page: number = 1,
    pageSize: number = 100000
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.list + packageId + '&IsActive=true',
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(id: number, page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.getById + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getlistByEducationPackageId(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.listByEducationPackageId + id,
      new CommonHttpOption().headers
    );
  }

  add(data: ILevelInfo): Observable<any> {
    return this.core.post(
      ServiceRoute.levelInfo.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ILevelInfo): Observable<any> {
    return this.core.put(
      ServiceRoute.levelInfo.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  active(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.levelInfo.active,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data): Observable<any> {
    return this.core.delete(
      ServiceRoute.levelInfo.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  SaveLevelToPerson(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.levelInfo.SaveLevelToPerson,
      data,
      new CommonHttpOption().headers
    );
  }

  ListLevelPerson(nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.levelInfo.ListLevelPerson + nationalCode,
      new CommonHttpOption().headers
    );
  }
}
